import { createContext } from 'react';

import type { XYChartOnEventPayload } from '../types/xy-chart-props.js';

export type XYChartOnEventContextValue = {
  onEvent?: (payload: XYChartOnEventPayload) => void;
};

export const XYChartOnEventContext = createContext<XYChartOnEventContextValue>(
  {},
);

XYChartOnEventContext['displayName'] = 'XYChartOnEventContext';
